export const fbTrack = (eventName, params, eventId) => {
  if (typeof window === "undefined" || typeof window.fbq !== "function") return;

  if (eventId) {
    window.fbq("track", eventName, params || {}, { eventID: eventId });
  } else if (params) {
    window.fbq("track", eventName, params);
  } else {
    window.fbq("track", eventName);
  }
};

const readCookie = (name) => {
  if (typeof document === "undefined") return null;

  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

// The Conversions API backend lives on a different subdomain than the
// storefront, so the browser never sends the Pixel's _fbc/_fbp cookies to it
// automatically — we have to read them here and pass them along explicitly.
export const getFbContext = () => {
  let fbc = readCookie("_fbc");

  if (!fbc && typeof window !== "undefined") {
    const fbclid = new URLSearchParams(window.location.search).get("fbclid");
    if (fbclid) {
      fbc = `fb.1.${Date.now()}.${fbclid}`;
    }
  }

  return {
    fbp: readCookie("_fbp"),
    fbc,
    eventSourceUrl: typeof window !== "undefined" ? window.location.href : null,
  };
};
